import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=f85d7c68&scoped=true&"
import script from "./BaseTextInput.vue?vue&type=script&lang=js&"
export * from "./BaseTextInput.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=f85d7c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d7c68",
  null
  
)

export default component.exports